import {
  Component,
  Input,
  OnInit
} from '@angular/core';
import { NgbActiveModal }          from '@ng-bootstrap/ng-bootstrap';

import { ApiService }    from '../api/api.service';
import { VehicleModel }  from './models/vehicle';

@Component({
  selector   : 'wor-vehicle-form-settings',
  template: require('./vehicle.form-settings.component.html')
})
export class VehicleFormSettingsComponent implements OnInit {
  @Input() vehicle: VehicleModel;

  formList: Array<any> = [];
  settings = {
    form_code: '',
    vehicle  : null as VehicleModel
  };

  constructor (
    public  activeModal: NgbActiveModal,
    private apiService : ApiService
  ) {}

  ngOnInit () : void {
    this.settings.vehicle = this.vehicle;

    this.apiService.get('/system/vehicle_forms_for_state')
    .then(( formList : Array<any> ) => {
      this.formList = formList;
    });
  }

  confirm () : void {


    this.activeModal.close(this.settings);


    };


  }
